import React, { useEffect, useRef } from 'react';
import lobby from '../assets/lobby.png';
import exterior from '../assets/reception2.jpeg'

const EXTERIOR = exterior;
const LOBBY    = '/src/assets/lobby.png';

function useFade(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
      }
    }, { threshold: 0.1 });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [ref]);
}

const stats = [
  ['12', 'Rooms'], ['3', 'Categories'], ['5', 'Amenities'],
  ['850m', 'Railway Stn'], ['1.5km', 'Mahakal'], ['24/7', 'Service'],
];

export default function About() {
  const leftRef  = useRef(null);
  const rightRef = useRef(null);
  useFade(leftRef);
  useFade(rightRef);

  const fadeBase = {
    opacity: 0, transform: 'translateY(28px)',
    transition: 'opacity 0.9s ease, transform 0.9s ease',
  };

  return (
    <>
      <style>{`
        .about-stat:hover { background: rgba(27,47,110,0.06) !important; }
        @media(max-width:860px){
          .about-grid { grid-template-columns: 1fr !important; }
          .about-imgs { padding-bottom: 48px !important; padding-right: 48px !important; }
        }
      `}</style>

      <section id="about" style={{ padding: '7rem 3rem', background: '#F2E8D9' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <div className="about-grid" style={{
            display: 'grid', gridTemplateColumns: '1fr 1fr',
            gap: '5rem', alignItems: 'center',
          }}>
            {/* Images */}
            <div className="about-imgs" ref={leftRef} style={{
              ...fadeBase,
              position: 'relative', paddingBottom: '64px', paddingRight: '64px',
              transitionDelay: '0.1s',
            }}>
              <img src={EXTERIOR} alt="Shree Maya Comfort Inn"
                style={{ width:'100%', aspectRatio:'3/4', objectFit:'cover',
                  border:'1px solid rgba(201,168,76,0.35)', display:'block' }} />
              <img src={lobby} alt="Hotel lobby"
                style={{
                  position:'absolute', bottom:0, right:0, width:'58%',
                  aspectRatio:'4/5', objectFit:'cover',
                  border:'2px solid #C9A84C',
                  boxShadow:'0 12px 40px rgba(42,31,14,0.2)',
                }} />
              {/* Gold corner accent */}
              <div style={{
                position:'absolute', top:'-16px', left:'-16px',
                width:'48px', height:'48px',
                borderTop:'2px solid #C9A84C', borderLeft:'2px solid #C9A84C',
              }}/>
            </div>

            {/* Text */}
            <div ref={rightRef} style={{ ...fadeBase, transitionDelay: '0.25s' }}>
              {/* Rule */}
              <div style={{ display:'flex', alignItems:'center', gap:'0.8rem', marginBottom:'1.2rem' }}>
                <div style={{ width:'32px', height:'1px', background:'#C9A84C' }}/>
                <div style={{ width:'5px', height:'5px', background:'#C9A84C', transform:'rotate(45deg)' }}/>
              </div>

              <p style={{ fontFamily:"'Jost',sans-serif", fontSize:'0.6rem', letterSpacing:'5px',
                textTransform:'uppercase', color:'#C9A84C', marginBottom:'0.7rem', fontWeight:400 }}>
                Our Story
              </p>

              <h2 style={{ fontFamily:"'Cinzel',serif", fontSize:'clamp(1.9rem,3.5vw,2.8rem)',
                fontWeight:500, color:'#1B2F6E', lineHeight:1.1, marginBottom:'0.4rem' }}>
                A Sanctuary of
              </h2>
              <h2 style={{ fontFamily:"'Cormorant',serif", fontSize:'clamp(2rem,4vw,3.2rem)',
                fontWeight:400, fontStyle:'italic', color:'#C9A84C', lineHeight:1.1, marginBottom:'1.5rem' }}>
                Comfort &amp; Grace
              </h2>

              <p style={{ fontFamily:"'EB Garamond',serif", fontSize:'1.05rem', lineHeight:1.95,
                color:'rgba(42,31,14,0.72)', marginBottom:'1.1rem', maxWidth:'480px' }}>
                Shree Maya Comfort Inn offers 12 thoughtfully appointed Superior rooms in the
                heart of Ujjain. Perfectly placed just 800 metres from the Railway Station
                and 1.5 kilometres from the sacred Mahakal Mandir &amp; Corridor.
              </p>
              <p style={{ fontFamily:"'EB Garamond',serif", fontSize:'1.05rem', lineHeight:1.95,
                color:'rgba(42,31,14,0.65)', maxWidth:'480px' }}>
                From plush king-size beds to warm ambient lighting, every detail is curated for
                an exceptional stay. Our dedicated team is available around the clock to ensure
                your comfort.
              </p>

              {/* Stats */}
              <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'0.7rem', marginTop:'2.2rem' }}>
                {stats.map(([n,l]) => (
                  <div key={l} className="about-stat" style={{
                    padding:'1.1rem 0.8rem', textAlign:'center',
                    border:'1px solid rgba(201,168,76,0.25)',
                    transition:'background .3s',
                  }}>
                    <div style={{ fontFamily:"'Cinzel',serif", fontSize:'1.8rem',
                      fontWeight:600, color:'#1B2F6E' }}>{n}</div>
                    <div style={{ fontFamily:"'Jost',sans-serif", fontSize:'0.55rem',
                      letterSpacing:'3px', textTransform:'uppercase',
                      color:'rgba(92,74,48,0.6)', marginTop:'0.2rem' }}>{l}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
